import React, { JSX } from 'react';
import { observer } from 'mobx-react';

import Toast from './Toast';
import useNotificationStore from '../../Hooks/useNotificationStore';
import { Notification } from '../../Storage/NotificationStore';
import { hashObject } from '../../Util/HashUtil';

const NotificationProvider = observer(function NotificationProvider(): JSX.Element {
  const notificationStore = useNotificationStore();

  return (
    <div className={'notification-container'}>
      {notificationStore.notifications.map((notification: Notification) => (
        <Toast
          key={hashObject(notification)}
          message={notification.message}
          onClose={() => {
            if (notification.onClose) {
              notification.onClose();
            }
            notificationStore.remove(notification);
          }}
          open={true}
          type={notification.type}
          actions={notification.actions}
          duration={notification.duration}
        />
      ))}
    </div>
  );
});

export default NotificationProvider;
